import fetch from "@lib/fetch";
import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { contactInformationCacheKey } from "./constants";
import type { CompanyContactInformationPayload } from "./types";

export const getCompanyContactInformation = reactQueryFetcherAdapter(
  contactInformationCacheKey,
  async (signal, companyId: string): Promise<CompanyContactInformationPayload> => {
    return fetch(`/companies/${companyId}/contact_information`, "GET", undefined, { signal });
  }
);
